/* istanbul ignore file */
import { createContext } from 'react';

import { PromoCodeContextProperties } from './promoCodeContext.types';

export const PromoCodeContext = createContext<PromoCodeContextProperties>({
    setCode: () => {},
    code: null,
});
